module.exports = __webpack_public_path__ + "img/inception_annotation_assessment.3f1d7659.svg";